import { Component, Prop, Vue } from 'vue-property-decorator';
import InputBase from '@/components/inputs/base/InputBase';

@Component
export default class InputCheckbox extends InputBase<boolean> {
  @Prop() public secondLabel?: string;
  private checked?: boolean = false;

  protected mounted() {
    this.inputType = 'checkbox';
    this.checked = (this.value === true);
  }

  protected onChange(event: any) {
    this.checked = event.currentTarget.checked;
    this.$emit('input', event.currentTarget.checked);
  }

  /**
   * Override onValueChanged from InputBase
   */
  protected onValueChanged(value: boolean, oldValue: boolean) {
    if (oldValue !== value && value !== undefined) {
      this.checked = (this.value === true);
    }
  }
}
